import Vue from 'vue'
import VueI18n from 'vue-i18n'
import connector from './connectors/i18n'

Vue.use(VueI18n)
const i18nConnector = connector()

function loadLocaleMessages () {
  const locales = require.context('./locales/translations', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

function missingTranslate (lang, missingKey, vueInstance) {
  return i18nConnector.logMissing(lang, missingKey)
    .then((r) => {})
    .catch((e) => '')
}

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages(),
  missing: missingTranslate
})
